<template>
  <div>
    <el-descriptions
      :title="t('accounts.userInfo')"
      :column="isMobile ? 1 : 2"
      border
      class="mb-5"
    >
      <el-descriptions-item :label="t('users.realName')">
        {{ formData.name }}
      </el-descriptions-item>
      <el-descriptions-item :label="t('users.identityNo')">
        {{ formData.identity_no }}
      </el-descriptions-item>
      <el-descriptions-item :label="t('users.birthday')">
        {{ dateFormat(formData.birthday) }}
      </el-descriptions-item>
      <el-descriptions-item :label="t('users.buyerAddress')">
        [{{ formData.postcode }}]
        {{ formData.province }}
        {{ formData.city }}
        {{ formData.region }}
        {{ formData.address }}
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions
      :title="t('accounts.createBankAccount')"
      :column="isMobile ? 1 : 2"
      border
      class="mb-5"
    >
      <el-descriptions-item :label="t('bankInfo.bank')">
        {{ formData.bank_name }}
      </el-descriptions-item>
      <el-descriptions-item :label="t('bankInfo.branch')">
        {{ formData.bank_branch_name }}
      </el-descriptions-item>
      <el-descriptions-item :label="t('bankInfo.accountName')">
        {{ formData.account_name }}
      </el-descriptions-item>
      <el-descriptions-item :label="t('bankInfo.accountNo')">
        {{ formData.account_no }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { useVModel } from "@vueuse/core"
import { dateFormat, breakpoint } from "../../../utils"

const { t } = useI18n()

const props = defineProps({
  modelValue: Object,
})
const emit = defineEmits(["update:modelValue"])

const formData = useVModel(props, "modelValue", emit)
const isMobile = computed(() => breakpoint.value.xs || breakpoint.value.sm)
</script>

<style></style>
